
export default function WhyChooseUs() {
  const benefits = [
    {
      icon: 'ri-user-star-line',
      title: 'Expert Consultants',
      description: 'Our team comprises industry veterans with proven track records in corporate strategy, finance, technology, and international business operations.'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Personalized Approach',
      description: 'We tailor every solution to your specific business needs, ensuring strategies align perfectly with your organizational goals and market context.'
    },
    {
      icon: 'ri-global-line',
      title: 'Global Expertise',
      description: 'Extensive experience in international markets enables us to navigate complex cross-border regulations and cultural nuances effectively.'
    },
    {
      icon: 'ri-bar-chart-box-line',
      title: 'Proven Results',
      description: 'Our data-driven methodologies and strategic frameworks have consistently delivered measurable improvements in client performance and profitability.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Compliance Focused',
      description: 'We ensure all solutions meet regulatory requirements and industry standards, minimizing risk while maximizing operational efficiency.'
    },
    {
      icon: 'ri-time-line',
      title: 'Timely Delivery',
      description: 'We respect your time and business priorities, delivering projects on schedule without compromising quality or thoroughness.'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Why Choose Auralis Consulting
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Partner with a consulting firm that combines deep expertise, innovative thinking, and unwavering commitment to your success
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl p-8 shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100"
            >
              <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-5">
                <i className={`${benefit.icon} text-2xl text-blue-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {benefit.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
